//
// Javascript for HelpControl
//
//  Ben Ramey
//  February 2010
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.HelpControl = function()
{
  if ($("div.help-control").length == 0)
    return;
};

HEIJS.Controls.HelpControl.prototype =
{
};

$(document).ready(
  function()
  {
    HEIJS.page.helpControl = new HEIJS.Controls.HelpControl();
  }
);